import { useTranslation } from "react-i18next";

import { Tooltip } from "@fluentui/react-components";
import {
  DismissRegular,
  DocumentCheckmarkRegular,
  DocumentDismissRegular,
  WarningRegular,
} from "@fluentui/react-icons";
import { OfferAzureSearch } from "library/types/types_old";
import { useTaxonomy } from "library/utils/useTaxonomy";

export const StatusCell = ({ offer }: { offer: OfferAzureSearch }) => {
  const { t } = useTranslation();
  const taxonomy = useTaxonomy();
  const offerStatusCodeTax = taxonomy?.SAGStatus?.byId[offer.Status];
  if (!offerStatusCodeTax) return null;

  const policyStatusMessage = offer?.PolicyStatusMessage;
  const policyDocumentsStatusMessage = offer?.PolicyDocumentsStatusMessage;

  let tooltipMessage = <p>{t(offerStatusCodeTax.code)}</p>;
  if (policyStatusMessage || policyDocumentsStatusMessage) {
    tooltipMessage = (
      <>
        <p>{policyStatusMessage ? policyStatusMessage : null}</p>
        <p>
          {policyStatusMessage && policyDocumentsStatusMessage ? <br /> : null}
          {policyDocumentsStatusMessage ? policyDocumentsStatusMessage : null}
        </p>
      </>
    );
  }

  const insurerIcon = (
    <img
      src={`/insurers/${offer.SelectedInsurer}.png`}
      style={{
        width: "20px",
        height: "20px",
        verticalAlign: "middle",
      }}
      alt={offer.SelectedInsurer || ""}
    />
  );
  const warningOverlayImage = offer.PolicyStatusMessage ? (
    <WarningRegular
      style={{
        color: "orange",
        position: "absolute",
        top: "8px",
        left: "8px",
        fontSize: "14px",
      }}
    />
  ) : null;
  const documentErrorOverlayImage = offer.PolicyDocumentsStatusMessage ? (
    <DismissRegular
      style={{
        color: "red",
        position: "absolute",
        bottom: "8px",
        left: "32px",
      }}
    />
  ) : null;
  const overlayImages = (
    <>
      {documentErrorOverlayImage}
      {warningOverlayImage}
    </>
  );

  let icon;

  if (offerStatusCodeTax.code === "SAGStatus.OFFER") {
    if (policyStatusMessage) {
      icon = <DocumentDismissRegular fontSize={24} />;
    } else {
      icon = <DocumentCheckmarkRegular fontSize={24} />;
    }
  } else {
    icon = (
      <>
        {insurerIcon}
        {overlayImages}
      </>
    );
  }

  const iconWithTooltip = (
    <Tooltip content={tooltipMessage} relationship="label">
      <div>{icon}</div>
    </Tooltip>
  );

  return (
    <div
      style={{
        cursor: "default",
        marginLeft: "10px",
      }}
    >
      {iconWithTooltip}
    </div>
  );
};
